import React, { Component } from 'react'
class DispatchClearance extends Component {
    render() {
        return (
            <div className="container">
                <div className="w-60 mx-auto shadow p-3" style={{ marginTop: "5%" }}>
                    <div className="container table-responsive py-5">
                        <table className="table table-bordered">
                            <thead className="thead-dark">
                                <tr>
                                    <th scope="col"><input type="checkbox"/></th>
                                    <th scope="col">DC No</th>
                                    <th scope="col">Project No</th>
                                    <th scope="col">Select Template</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="row"><input type="checkbox"/></th>
                                    <td>123-1</td>
                                    <td>4456778</td>
                                    <td>1</td>
                                </tr>
                            </tbody>
                        </table><br/>
                        <div className="float-right"><button type="submit" className="btn btn-danger btn-lg">Issue DC</button></div>
                    </div>
                </div>
            </div>
        )
    }
}
export default DispatchClearance;